import { Icon } from "@design-system/Icon";
import { FlexCol } from "@design-system/Layout/Flex";

import { Text } from "@design-system/Typography/Text";
import { useAtomValue } from "jotai";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { StringParam, useQueryParam } from "use-query-params";
import {
    selectedSubthemesAtomFamily,
    selectedThemesAtomFamily,
    selectedUsersAtomFamily,
} from "../../ctx";
import { keys, RESOURCE_NAME } from "./i18n";

export const EmptySearchState: FC = () => {
    const { t } = useTranslation(RESOURCE_NAME);
    const { org_uname } = useParams();
    const [urlSearchString] = useQueryParam("search", StringParam);
    const selectedThemesIds = useAtomValue(selectedThemesAtomFamily(org_uname));
    const selectedSubthemesIds = useAtomValue(
        selectedSubthemesAtomFamily(org_uname),
    );
    const selectedUserIds = useAtomValue(selectedUsersAtomFamily(org_uname));

    const hasActiveFilters =
        !!urlSearchString?.length ||
        selectedSubthemesIds.length > 0 ||
        selectedThemesIds.length > 0 ||
        selectedUserIds.length > 0;

    return (
        <FlexCol
            py="10"
            justifyContent="center"
            alignItems="center"
            w="full"
            className="bg-neutral-25"
        >
            <FlexCol gap="2" alignItems="center" className="my-8">
                {hasActiveFilters && <Icon name="search" />}
                <FlexCol gap="1" alignItems="center">
                    <Text variant="body-sm-bold">
                        {hasActiveFilters
                            ? t(keys.empty_state_search_title)
                            : t(keys.empty_state_initial_title)}
                    </Text>
                    <Text variant="body-sm" className="font-light">
                        {hasActiveFilters
                            ? t(keys.empty_state_search_subtitle)
                            : t(keys.empty_state_initial_subtitle)}
                    </Text>
                </FlexCol>
            </FlexCol>
        </FlexCol>
    );
};
